// based on rc-collapse 1.11.8
import CollapsePanel from './src/Panel';
import Collapse from './src/Collapse';
import { collapseProps, panelProps } from './src/commonProps';

Collapse.Panel = CollapsePanel;

export { collapseProps, panelProps };
export default Collapse;


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-collapse/index.js
// module id = 348
// module chunks = 0